/* Delilah wishlist + product card image slider.
   Wishlist: hearts [data-dl-wish="handle"] toggle a saved list. Saved in this browser (localStorage);
   when a customer is logged in the list is kept under their account id on this device, and any
   items saved before logging in are merged in. Header button [data-dl-wl-open] opens the list drawer,
   [data-dl-wl-count] shows the count. Items can be added to the basket (single variant) or opened.
   Card slider: [data-dl-cs] scroll-snap rows get dots and prev/next arrows. */
(function () {
  if (window.DelilahWishlist) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cid = window.DelilahCustomerId || '';
  var KEY = 'dl-wishlist' + (cid ? '-' + cid : '');

  function read(k) { try { return JSON.parse(localStorage.getItem(k) || '[]') || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  // merge guest list into the customer's list after login
  if (cid) {
    var guest = read('dl-wishlist');
    if (guest.length) {
      var mine = read(KEY);
      guest.forEach(function (h) { if (mine.indexOf(h) === -1) mine.push(h); });
      write(mine);
      try { localStorage.removeItem('dl-wishlist'); } catch (e) {}
    }
  }
  var list = read(KEY);
  var cache = {};

  function has(h) { return list.indexOf(h) > -1; }
  function sync(noPanel) {
    document.querySelectorAll('[data-dl-wish]').forEach(function (b) {
      var on = has(b.getAttribute('data-dl-wish'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
    });
    document.querySelectorAll('[data-dl-wl-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
    if (!noPanel && panel && panel.classList.contains('is-open')) renderList();
  }
  function toggle(h) {
    if (has(h)) list.splice(list.indexOf(h), 1); else list.unshift(h);
    write(list); sync();
    var btn = document.querySelector('[data-dl-wl-open]');
    if (btn && has(h)) { btn.classList.remove('dl-wl-bump'); void btn.offsetWidth; btn.classList.add('dl-wl-bump'); }
  }

  /* ---------- drawer ---------- */
  var panel, overlay, body;
  function money(c) { return '£' + (c / 100).toFixed(2); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function build() {
    overlay = document.createElement('div'); overlay.className = 'dl-wl-overlay'; overlay.addEventListener('click', close);
    panel = document.createElement('aside'); panel.className = 'dl-wl'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); panel.setAttribute('aria-label', 'Wishlist');
    panel.innerHTML = '<div class="dl-wl__head"><div><div class="dl-wl__kicker">Saved for later</div><div class="dl-wl__title">Your wishlist <span>♡</span></div></div><button type="button" class="dl-wl__close" aria-label="Close wishlist">✕</button></div><div class="dl-wl__body"></div>' +
      '<div class="dl-wl__foot">' + (cid ? 'Saved to your account on this device.' : 'Saved on this device. <a href="' + root + 'account/login">Log in</a> to keep it with your account.') + '</div>';
    panel.querySelector('.dl-wl__close').addEventListener('click', close);
    body = panel.querySelector('.dl-wl__body');
    document.body.appendChild(overlay); document.body.appendChild(panel);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  function open() { if (!panel) build(); renderList(); panel.classList.add('is-open'); overlay.classList.add('is-open'); document.documentElement.classList.add('dl-wl-lock'); panel.querySelector('.dl-wl__close').focus(); }
  function close() { if (!panel) return; panel.classList.remove('is-open'); overlay.classList.remove('is-open'); document.documentElement.classList.remove('dl-wl-lock'); }
  function fetchP(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch(root + 'products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) { cache[h] = p; return p; }).catch(function () { return null; });
  }
  function renderList() {
    if (!list.length) {
      body.innerHTML = '<div class="dl-wl__empty"><div class="dl-wl__emptyheart">♡</div><b>Nothing saved yet</b><p>Tap the heart on any piece to save it here for later.</p></div>';
      return;
    }
    body.innerHTML = list.map(function (h) { return '<div class="dl-wl__item is-loading" data-h="' + esc(h) + '"></div>'; }).join('');
    list.forEach(function (h) {
      fetchP(h).then(function (p) {
        var el = body.querySelector('[data-h="' + h.replace(/"/g, '') + '"]'); if (!el) return;
        if (!p) { el.remove(); return; }
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        var img = p.featured_image ? (p.featured_image.indexOf('?') > -1 ? p.featured_image + '&width=200' : p.featured_image + '?width=200') : '';
        var single = p.variants.length === 1;
        var cta = !p.available ? '<span class="dl-wl__btn is-off">Sold out</span>' :
          (single ? '<button type="button" class="dl-wl__btn" data-dl-add="' + v.id + '" data-dl-open="false"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1 12H6z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg><span>Add</span></button>'
                  : '<a class="dl-wl__btn" href="' + p.url + '"><span>Choose</span></a>');
        el.classList.remove('is-loading');
        el.innerHTML = '<a class="dl-wl__img" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="dl-wl__info"><a class="dl-wl__name" href="' + p.url + '">' + esc(p.title) + '</a><div class="dl-wl__price">' + money(p.price) +
          (p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '') + '</div>' + cta + '</div>' +
          '<button type="button" class="dl-wl__rm" data-dl-wish="' + esc(h) + '" aria-label="Remove from wishlist">✕</button>';
      });
    });
  }

  document.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('[data-dl-wish]');
    if (w) { e.preventDefault(); e.stopPropagation(); toggle(w.getAttribute('data-dl-wish')); return; }
    var o = e.target.closest && e.target.closest('[data-dl-wl-open]');
    if (o) { e.preventDefault(); open(); }
  }, true);

  /* ---------- product card image slider ---------- */
  function initSliders(scope) {
    (scope || document).querySelectorAll('[data-dl-cs]:not([data-ready])').forEach(function (cs) {
      cs.setAttribute('data-ready', '');
      var wrap = cs.closest('.product-card__media'); if (!wrap) return;
      var dots = wrap.querySelectorAll('.dl-cs__dot');
      var n = cs.children.length;
      function idx() { return Math.round(cs.scrollLeft / Math.max(cs.clientWidth, 1)); }
      function upd() { var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); wrap.setAttribute('data-cs-i', i); wrap.classList.toggle('cs-first', i === 0); wrap.classList.toggle('cs-last', i >= n - 1); }
      cs.addEventListener('scroll', upd, { passive: true });
      wrap.querySelectorAll('[data-dl-cs-go]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); var d = Number(b.getAttribute('data-dl-cs-go')); cs.scrollTo({ left: (idx() + d) * cs.clientWidth, behavior: 'smooth' }); });
      });
      upd();
    });
  }
  function boot() { sync(); initSliders(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // collection pages can re-render the grid (pagination / filters): pick up new cards
  var mt;
  new MutationObserver(function (m) {
    var add = false;
    m.forEach(function (r) { if (r.addedNodes.length && !(panel && panel.contains(r.target))) add = true; });
    if (add) { clearTimeout(mt); mt = setTimeout(function () { initSliders(); sync(true); }, 120); }
  }).observe(document.body, { childList: true, subtree: true });

  window.DelilahWishlist = { open: open, toggle: toggle, list: function () { return list.slice(); } };
})();
